import React, { useEffect, useState, useRef, useCallback } from 'react'
import CSS from './styles.module.css'

const HorizontalAccordion = () => {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [isVisible, setIsVisible] = useState(false)
  const [initialLoad, setInitialLoad] = useState(false)

  const postsPerPage = 10
  const maxPosts = 100
  const containerRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        if (entry.isIntersecting && !initialLoad) {
          setIsVisible(true)
        }
      },
      { threshold: 0.1 }
    )

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current)
      }
    }
  }, [initialLoad])

  const fetchData = useCallback(
    async (page = 1, append = false) => {
      const controller = new AbortController()
      const signal = controller.signal

      try {
        if (page === 1) {
          setLoading(true)
        } else {
          setLoadingMore(true)
        }

        const response = await fetch(
          `https://recooty.com/blog/wp-json/wp/v2/hr_resource?per_page=${postsPerPage}&page=${page}&_fields=title,link,resources`,
          { signal }
        )
        const data = await response.json()

        if (append) {
          const currentTotal = posts.length
          const remainingSlots = maxPosts - currentTotal
          const postsToAdd = data.slice(0, remainingSlots)
          setPosts((prevPosts) => [...prevPosts, ...postsToAdd])

          setHasMore(
            currentTotal + postsToAdd.length < maxPosts &&
              data.length === postsPerPage
          )
        } else {
          const postsToSet = data.slice(0, maxPosts)
          setPosts(postsToSet)

          setHasMore(
            postsToSet.length < maxPosts && data.length === postsPerPage
          )
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted')
        } else {
          console.error('Error fetching data:', error)
        }
      } finally {
        setLoading(false)
        setLoadingMore(false)
      }

      return () => {
        controller.abort()
      }
    },
    [postsPerPage, maxPosts, posts.length]
  )

  useEffect(() => {
    if (isVisible && !initialLoad) {
      setInitialLoad(true)
      fetchData(1, false)
    }
  }, [isVisible, initialLoad, fetchData])

  const handleLoadMore = () => {
    const nextPage = currentPage + 1
    setCurrentPage(nextPage)
    fetchData(nextPage, true)
  }

  const SkeletonItem = () => (
    <div className={CSS.SkeletonItem}>
      <div className={CSS.SkeletonText}></div>
      <div className={CSS.SkeletonChevron}></div>
    </div>
  )

  return (
    <div ref={containerRef} className={CSS.HorizontalAccordionmain}>
      <h2 className={CSS.Heading}>Job descriptions for various major role</h2>

      {loading ? (
        <>
          <div className={CSS.CategoryHeader}>
            {/* <div className={CSS.CategorySubHeader}>
              <span className={CSS.CategoryIcon} style={{ fontSize: 20 }}>
                <span className="material-symbols-outlined">folder_open</span>
              </span>
              <h3>Job descriptions for various major roles</h3>
            </div> */}
          </div>
          <div className={CSS.AccordionContainer}>
            {Array.from({ length: postsPerPage }).map((_, index) => (
              <SkeletonItem key={index} />
            ))}
          </div>
        </>
      ) : (
        <>
          <div className={CSS.CategoryHeader}>
            {/* <div className={CSS.CategorySubHeader}>
              <span className={CSS.CategoryIcon} style={{ fontSize: 20 }}>
                <span className="material-symbols-outlined">folder_open</span>
              </span>
              <h3>Job descriptions for various major roles</h3>
            </div> */}
          </div>

          <div className={CSS.AccordionContainer}>
            {posts.map((post) => (
              <a
                key={post.id}
                rel="noreferrer"
                target="_blank"
                href={post.link}
                className={CSS.AccordionItem}
              >
                <span
                  dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                ></span>
                <span
                  className="material-symbols-outlined"
                  style={{ fontSize: 16 }}
                >
                  chevron_right
                </span>
              </a>
            ))}

           
            {loadingMore &&
              Array.from({ length: postsPerPage }).map((_, index) => (
                <SkeletonItem key={`loading-${index}`} />
              ))}
          </div>

          {/* Load More Button */}
          {hasMore && !loadingMore && posts.length < maxPosts && (
            <div className={CSS.LoadMoreContainer}>
              <button
                className={CSS.LoadMoreButton}
                onClick={handleLoadMore}
                disabled={loadingMore}
              >
                Load More
              </button>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default HorizontalAccordion
